import { defineComponent as _defineComponent } from 'vue'
import { observeElementIntersection } from '@@/bits/intersection'
import { requestIdleCallback } from '@@/bits/request_idle_callback'
import { onMounted, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceLazy',
  props: {
    tag: { default: 'div' },
    minHeight: null,
    minWidth: null,
    renderImmediately: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { tag: string, minHeight: number, minWidth: number, renderImmediately: boolean };



const isVisible = ref(props.renderImmediately)
const rootElement = ref<HTMLElement | null>(null)

onMounted(() => {
  if (isVisible.value) return
  requestIdleCallback(() => {
    if (rootElement.value === null) return
    observeElementIntersection(rootElement.value, () => {
      requestIdleCallback(() => {
        isVisible.value = true
      })
    })
  })
})

return { __sfc: true,props, isVisible, rootElement }
}

})